import { REVENUE_RECOGNITION_TYPE, type CustomerRevenueReportItem, type RevenueRecognitionType } from '@vy/types';
import type { RevenuePoint } from './types';

export function getContractStartDay(row: CustomerRevenueReportItem): Date {
  return row.contract?.startDate ? new Date(row.contract.startDate) : new Date();
}

export function buildSinglePoint(row: CustomerRevenueReportItem, sessionTotal: number): RevenuePoint {
  return { date: getContractStartDay(row), amount: sessionTotal };
}

export function normalizeSinglePoint(
  points: RevenuePoint[],
  sessionTotal: number,
  fallbackDate: Date,
): RevenuePoint[] {
  return [{ date: points[0]?.date ?? fallbackDate, amount: sessionTotal }];
}

type RecognitionTransitionInput = {
  nextType: RevenueRecognitionType;
  row: CustomerRevenueReportItem;
  sessionTotal: number;
  currentPoints: RevenuePoint[];
};

export function computeRecognitionTransition({
  nextType,
  row,
  sessionTotal,
  currentPoints,
}: RecognitionTransitionInput): { points?: RevenuePoint[] } {
  switch (nextType) {
    case REVENUE_RECOGNITION_TYPE.PointInTime:
      return { points: [buildSinglePoint(row, sessionTotal)] };
    case REVENUE_RECOGNITION_TYPE.Milestones:
      return { points: currentPoints };
    default:
      return {};
  }
}
